import React, { Component, Fragment } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import HelloSign from 'hellosign-embedded';

import {
  getCreateTemplateUrl, displayToaster, hideToaster, toggleDrawer,
  GET_CREATE_TEMPLATE_URL, clearLoadingState, saveTemplateMetadata,
  LOADING_PROP_TYPE,
} from '../../../../modules/index';
import { Drawer, DrawerHeader, LockedModalBody, ExitConfirmationModal } from '../../../index';
import { APPLICATION_ROOT, ESIGN_DEV_MODE } from '../../../../constants/index';

const DEFAULT_STATE = {
  drawerClasses: ['drawer', 'wider'],
  helloSignClient: undefined,
  confirmationModalIsOpen: false,
};

class HellosignContainer extends Component {
  constructor(props) {
    super(props);
    this.state = DEFAULT_STATE;

    this.handleDrawer = this.handleDrawer.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { createTemplateData: { template: { editUrl, id }, clientId }, resetCreateTemplateState } = this.props;
    const { createTemplateData: { template: { editUrl: prevEditUrl } } } = prevProps;
    const container = document.getElementById('template-container');
    let client;
    if (editUrl && editUrl !== prevEditUrl) {
      client = new HelloSign({ clientId });
      client.open(
        editUrl,
        { container, skipDomainVerification: ESIGN_DEV_MODE }
      );
    }
    if (client) {
      client.on('createTemplate', () => {
        this.props.displayToaster([
          'success',
          <FormattedMessage id="TEMPLATE_CREATED" />,
          'app',
          5000,
          true,
        ]);
        this.handleDrawer();
        const {
          file: droppedFile, uploadTemplateValues: { category, title },
        } = this.props;
        const { file: { name: fileName } } = droppedFile;
        this.props.saveTemplateMetadata({
          id, fileName, category, title,
        });
        client.close();
        resetCreateTemplateState();
      });
      client.on('ready', () => {
        const { drawerClasses } = this.state;
        this.setState({
          drawerClasses: [...drawerClasses],
          helloSignClient: client,
        });
      });
    }
  }

  handleDrawer() {
    const { drawerIsOpen } = this.props;
    const { helloSignClient } = this.state;

    if (helloSignClient && drawerIsOpen) helloSignClient.close();
    this.props.toggleDrawer(false);
    this.props.hideToaster('drawer');
    this.props.clearLoadingState(GET_CREATE_TEMPLATE_URL);
  }

  closeConfirmationModal(quitTemplateCreation) {
    this.setState({ confirmationModalIsOpen: false });
    if (quitTemplateCreation) {
      this.handleDrawer();
      this.props.resetCreateTemplateState();
    }
  }

  render() {
    const {
      drawerClasses,
    } = this.state;
    const {
      loading,
      drawerIsOpen,
    } = this.props;
    const isLoading =
        loading[GET_CREATE_TEMPLATE_URL] === 'loading';
    const containerClasses = ['hello-sign-container', 'w-100', 'h-100'];
    if (loading[GET_CREATE_TEMPLATE_URL] && loading[GET_CREATE_TEMPLATE_URL] !== 'error' && isLoading) {
      containerClasses.push('loading');
    }
    return (
      <Fragment>
        <ExitConfirmationModal
          closeConfirmationModal={quitTemplateCreation => this.closeConfirmationModal(quitTemplateCreation)}
          confirmationModalIsOpen={this.state.confirmationModalIsOpen}
        />
        <Drawer
          modalClassName={drawerClasses.join(' ')}
          toggle={() => {}}
          isOpen={drawerIsOpen}
          parentselector={APPLICATION_ROOT}
          backdrop={loading[GET_CREATE_TEMPLATE_URL] === 'loading' ? 'static' : true}
        >
          <DrawerHeader
            title="ADD_DOCUMENT"
            toggle={() => this.setState({ confirmationModalIsOpen: true })}
          />
          <LockedModalBody className="p-4 h-100">
            <div id="template-container" className={containerClasses.join(' ')} />
          </LockedModalBody>
        </Drawer>
      </Fragment>
    );
  }
}

HellosignContainer.defaultProps = {
  drawerIsOpen: false,
  uploadTemplateValues: null,
  file: null,
};

HellosignContainer.propTypes = {
  createTemplateData: PropTypes.shape({
    clientId: PropTypes.string,
    template: PropTypes.shape({
      editUrl: PropTypes.string,
      id: PropTypes.string,
    }),
  }).isRequired,
  displayToaster: PropTypes.func.isRequired,
  loading: LOADING_PROP_TYPE.isRequired,
  drawerIsOpen: PropTypes.bool,
  toggleDrawer: PropTypes.func.isRequired,
  hideToaster: PropTypes.func.isRequired,
  clearLoadingState: PropTypes.func.isRequired,
  saveTemplateMetadata: PropTypes.func.isRequired,
  resetCreateTemplateState: PropTypes.func.isRequired,
  uploadTemplateValues: PropTypes.shape({
    category: PropTypes.string,
    title: PropTypes.string,
  }),
  file: PropTypes.shape({
    file: PropTypes.shape({
      name: PropTypes.string,
    }),
  }),
};

export default connect(
  (state) => {
    const { resources: { templates: { createTemplate }, companies }, appState } = state;
    return {
      createTemplateData: createTemplate,
      companies,
      loading: appState.loading,
      drawerIsOpen: appState.drawer.isOpen,
    };
  },
  {
    getCreateTemplateUrl: (file, companyId, category, title) => getCreateTemplateUrl(file, companyId, category, title),
    displayToaster: args => displayToaster(...args),
    toggleDrawer: open => toggleDrawer(open),
    hideToaster: location => hideToaster(location),
    clearLoadingState: action => clearLoadingState(action),
    saveTemplateMetadata: postBody => saveTemplateMetadata(postBody),
  }
)(hot(module)(HellosignContainer));



// WEBPACK FOOTER //
// ./src/components/Forms/CreateTemplate/HelloSignContainer/HellosignContainer.jsx